import React from "react";
import { Link } from "react-router-dom";
import {
  Clock,
  Users,
  Gamepad2,
  Trophy,
  Calendar,
  MapPin,
  DollarSign,
  Star,
  Crown,
} from "lucide-react";
import {
  TimeStatus,
  TournamentCardProps,
  TournamentStatus,
  TournamentTypeEnum,
} from "../../../../common/services/tournament.types";
import { useAuth } from "../../../../common/store/authStore";
import { formatNumber } from "../../../../utils/formatNumber";

const TournamentCard: React.FC<TournamentCardProps> = ({
  tournament,
  userCountry,
  type,
  onAddToCalendar,
  onShare,
}) => {
  let timeStatus: TimeStatus = {
    status: TournamentStatus.UPCOMING,
    color: "#4CAF50",
  };
  if (tournament.status === TournamentStatus.LIVE) {
    timeStatus = {
      status: TournamentStatus.LIVE,
      color: "#FF5722",
    };
  } else if (tournament.status === TournamentStatus.COMPLETED) {
    timeStatus = {
      status: TournamentStatus.COMPLETED,
      color: "#9E9E9E",
    };
  } else if (tournament.status === TournamentStatus.CANCELLED) {
    timeStatus = {
      status: TournamentStatus.CANCELLED,
      color: "#F44336",
    };
  }

  const tournamentTypeDisplay = {
    [TournamentTypeEnum.SINGLE_ELIMINATION]: "Single Elimination",
    [TournamentTypeEnum.DOUBLE_ELIMINATION]: "Double Elimination",
    [TournamentTypeEnum.ROUND_ROBIN]: "Round Robin",
  };

  const displayName = tournamentTypeDisplay[tournament.tournamentType];
  const isHosted = type === "hosted";
  const { authenticatedUser } = useAuth();

  // const isHost = authenticatedUser?.id === tournament?.host?._id;
  // const isTournamentLive = tournament?.status === "live";
  // const hasParticipant =
  //   Array.isArray(tournament?.participants) &&
  //   tournament?.participants.length > 0;
  // const canDelete = isHost && !isTournamentLive && !hasParticipant;

  return (
    <div className="tournament-card" key={tournament._id}>
      <div className="card-header">
        <div className="tournament-image">
          <img
            src={tournament.tournamentImage}
            alt={tournament.tournamentName}
          />
          <div className="image-overlay" />
        </div>

        <div
          className="status-badge"
          style={{ backgroundColor: timeStatus.color }}
        >
          <Clock className="status-icon" size={12} />
          <span>{timeStatus.status}</span>
        </div>
        {isHosted && (
          <div className="host-badge">
            <Crown />
            <span>HOST</span>
          </div>
        )}
        <div className="game-badge">
          <img
            src={tournament.gameImageUrl}
            alt={tournament.selectedGame}
            className="game-icon"
          />
        </div>
      </div>

      <div className="card-body">
        <div className="tournament-info">
          <h3 className="tournament-name">{tournament?.tournamentName}</h3>
          {!isHosted && (
            <div className="host-info">
              <Users className="host-icon" size={16} />
              <span className="host-name">{tournament?.host?.username}</span>
            </div>
          )}
        </div>

        <div className="tournament-stats">
          <div className="stat-item">
            <Gamepad2 className="stat-icon" size={16} />
            <span className="stat-label">Game</span>
            <span className="stat-value">{tournament.selectedGame}</span>
          </div>

          <div className="stat-item">
            <Trophy className="stat-icon" size={16} />
            <span className="stat-label">Tournament Type</span>
            <span className="stat-value">{displayName}</span>
          </div>

          <div className="stat-item">
            <Calendar className="stat-icon" size={16} />
            <span className="stat-label">Date</span>
            <span className="stat-value">
              {tournament.convertedDateReadable}
            </span>
          </div>

          <div className="stat-item">
            <MapPin className="stat-icon" size={16} />
            <span className="stat-label">Location</span>
            <span className="stat-value">{tournament.location}</span>
          </div>
        </div>

        <div className="prize-section">
          <div className="prize-info">
            <div className="prize-item">
              <DollarSign className="prize-icon" size={16} />
              <div className="prize-details">
                <span className="prize-label">Prize Pool</span>
                <span className="prize-amount">
                  {tournament.displayCurrency} {formatNumber(tournament.convertedPrize)}
                </span>
              </div>
            </div>

            <div className="prize-item">
              <Trophy className="prize-icon" size={16} />
              <div className="prize-details">
                <span className="prize-label">Entry Fee</span>
                <span className="prize-amount">
                  {tournament.displayCurrency} {formatNumber(tournament.convertedFee)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-footer">
        <Link
          className="view-tournament-btn"
          to={`/tournaments/${tournament.tournamentURL}`}
          state={{ tournamentId: tournament._id, userCountry: userCountry }}
        >
          <span>
            {tournament.host._id === authenticatedUser?.id
              ? "Manage "
              : "View "}
            Tournament
          </span>
          <Star className="btn-icon" size={16} />
        </Link>

        {/* {isHosted && (
          <div style={{ marginTop: 20 }}>
            <button
              className="join-button delete-btn"
              // onClick={handleDeleteTournament}
              // disabled={!canDelete || deleteLoading}
              style={{
                background: canDelete ? "#ff4d4f" : "#ccc",
                color: "#fff",
                cursor: canDelete ? "pointer" : "not-allowed",
              }}
            >
              Delete Tournament
            </button>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                justifyContent: "center",
                marginTop: 10,
                marginBottom: 20,
              }}
            >
              <button
                className="action-btn secondary"
                onClick={() => onAddToCalendar(tournament)}
              >
                <FaCalendarPlus />
                Add to Calendar
              </button>

              <button
                className="action-btn secondary"
                onClick={() => onShare(tournament)}
              >
                <FaShare />
                Share
              </button>
            </div>
          </div>
        )} */}
      </div>

      <div className="card-glow" />
    </div>
  );
};

export default TournamentCard;
